module.exports = __webpack_public_path__ + "img/172094.2a2e96b2.svg";